import * as React from 'react'
import { GlossaryListGroup } from '../types'
import { Styled } from './Group.styled'
import { GroupItem } from './GroupItem'
import { GroupLetter } from './GroupLetter'

export const Group = ({ group, groups }: { group: GlossaryListGroup; groups: GlossaryListGroup[] }) => {
  const [menuOpen, setMenuOpen] = React.useState(false)

  const onOpen = React.useCallback(() => {
    setMenuOpen(true)
  }, [])

  const onClose = React.useCallback(() => {
    setMenuOpen(false)
  }, [])

  return (
    <Styled.Group key={group.id} id={group.id}>
      <Styled.GroupInner>
        <Styled.GroupLeft menuOpen={menuOpen}>
          <Styled.GroupLetterButtonContainer>
            <GroupLetter onOpen={onOpen} onClose={onClose} groups={groups} letter={group.letter} />
          </Styled.GroupLetterButtonContainer>
        </Styled.GroupLeft>
        <Styled.GroupRight>
          <Styled.ItemContent>
            {group.items.map(item => (
              <GroupItem item={item} key={item._uid} />
            ))}
          </Styled.ItemContent>
        </Styled.GroupRight>
      </Styled.GroupInner>
    </Styled.Group>
  )
}
